import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, StatPill, Loading } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { homePath } from "@/components/nav";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime, num } from "@/lib/format";

export default function AdminDashboard() {
  const { switchTenant } = useAuth();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const enter = async (id) => {
    try { nav(homePath(await switchTenant(id))); } catch (e) { toast.error(errMsg(e)); }
  };
  useEffect(() => {
    api.get("/admin/summary").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!d) return <Loading />;
  const t = d.totals;
  return (
    <div>
      <PageHeader sheet="ADMIN 01" title="Ringkasan Penggunaan Aplikasi" subtitle="Statistik penggunaan seluruh perusahaan. Klik Masuk untuk mengatur / mengawasi perusahaan (tercatat di audit log)." />
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-3 mb-6 fade-up">
        <StatPill label="Perusahaan" value={num(t.tenants)} testId="admin-stat-tenants" />
        <StatPill label="Aktif" value={num(t.active)} tone="green" testId="admin-stat-active" />
        <StatPill label="Pengguna" value={num(t.users)} tone="blue" testId="admin-stat-users" />
        <StatPill label="Pelanggan" value={num(t.customers)} testId="admin-stat-customers" />
        <StatPill label="Invoice" value={num(t.invoices)} tone="amber" testId="admin-stat-invoices" />
        <StatPill label="Pencetakan" value={num(t.prints)} testId="admin-stat-prints" />
      </div>
      <div className="xl-wrap">
        <table className="xl" data-testid="admin-usage-table">
          <thead><tr><th className="rownum">#</th><th>Perusahaan</th><th>Kode</th><th>Status</th><th className="text-right">Pengguna</th><th className="text-right">Pelanggan</th><th className="text-right">Invoice</th><th className="text-right">Disahkan</th><th className="text-right">Cetak</th><th>Aktivitas Terakhir</th><th>Aksi</th></tr></thead>
          <tbody>
            {d.tenants.map((r, i) => (
              <tr key={r.id}>
                <td className="rownum">{i + 1}</td><td className="font-semibold">{r.name}</td><td className="font-mono">{r.nota_code}</td>
                <td>{r.active ? <span className="text-emerald-700">Aktif</span> : <span className="text-rose-600">Nonaktif</span>}</td>
                <td className="num">{r.users}</td><td className="num">{r.customers}</td><td className="num">{r.invoices}</td><td className="num">{r.approved}</td><td className="num">{r.prints}</td>
                <td className="font-mono text-xs">{fmtDateTime(r.last_activity)}</td>
                <td><Button size="sm" variant="outline" className="h-7" onClick={() => enter(r.id)} data-testid={`admin-enter-${r.name}`}><LogIn className="h-3.5 w-3.5 mr-1" />Masuk</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
